import {
  EmbeddedDocumentPostMessageResult,
  IDocumentObjectsInformation
} from "./index";

export class EmbeddedDocumentObjectsPostMessageResult extends EmbeddedDocumentPostMessageResult {
  constructor(
    windowName: string,
    request: string,
    isOk: boolean,
    public document?: IDocumentObjectsInformation,
  ) {
    super(windowName, request, isOk);
  }
}
